import React from "react";
import stone2 from "../images/stone2.jpg";
import Navbars from "./Navbar";
import SocialIcons from "./SocialIcons";

const OurExpertise = () => {
  return (
    <>
      <Navbars />

      <section className="bg-gray-50 py-12 px-4 text-center min-h-screen flex flex-col justify-between">
        {/* Content Container */}
        <div className="flex-grow">
          {/* Heading Section */}
          <div className="max-w-4xl mx-auto mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Our Services
            </h2>
            <p className="text-gray-600 text-sm">
              Crafting Visual Masterpieces, One Frame at a Time
            </p>
            <p className="mt-4 text-gray-700 text-sm font-medium">
              At <span className="font-bold">StoneAge Films</span>, we
              specialize in creating unforgettable visual experiences that
              connect, engage, and inspire. Our services are tailored to meet
              your brand’s unique needs, ensuring every project stands out with
              bold creativity and flawless execution.
            </p>
          </div>

          {/* Image Section */}
          <div className="max-w-5xl mx-auto mb-10">
            <img
              src={stone2}
              alt="Our Expertise"
              className="w-full rounded-lg shadow-lg object-cover"
            />
          </div>

          {/* Cards Section */}
          <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Card 1 */}
            <div className="bg-white rounded-lg shadow-md p-6 text-left hover:shadow-xl transition">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Commercial Ads
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Transforming ideas into captivating visuals, we produce
                high-impact TV and digital commercials that resonate with
                audiences. Our expertise in storytelling and attention to detail
                ensures your message leaves a lasting impression.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-lg shadow-md p-6 text-left hover:shadow-xl transition">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Line Production Services
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                From concept to completion, our comprehensive line production
                services provide everything you need for a seamless shoot. We
                handle the details—location scouting, permits, logistics, and
                more—so you can focus on your vision.
              </p>
            </div>
          </div>
        </div>

        {/* Social Media Icons - Bottom Center */}
      </section>
      <SocialIcons />
    </>
  );
};

export default OurExpertise;
